<template>
  <div
    id="stepsNav"
    class="container row stappenContainer justify-content-around text-danger text-center"
  >
    <!-- <div
			class="
		> -->
    <div class="col-lg-2 col-12">
      <p :class="steps.step1.number">1</p>
      <p :class="steps.step1.tag" id="category">Assortiment keuze</p>
    </div>
    <div class="col-lg-2 col-12">
      <p :class="steps.step2.number">2</p>
      <p :class="steps.step2.tag" id="product-select">Product keuze</p>
    </div>
    <div class="col-lg-2 col-12">
      <p :class="steps.step3.number">3</p>
      <p :class="steps.step3.tag" id="product-detail">Product details</p>
    </div>
    <div class="col-lg-2 col-12">
      <p :class="steps.step4.number">4</p>
      <p :class="steps.step4.tag" id="contact">Contactgegevens</p>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
// MODIFY STEP NUMBER IN ROUTES: USE THE step PROPERTIE
export default {
  data() {
    return {
      steps: {
        step1: {
          number: "text-black",
          tag: "text-black text-uppercase",
        },
        step2: {
          number: "text-black",
          tag: "text-black text-uppercase",
        },
        step3: {
          number: "text-black",
          tag: "text-black text-uppercase",
        },
        step4: {
          number: "text-black",
          tag: "text-black text-uppercase",
        },
      },
      classes: {
        current: {
          number: "huidigeStapNummer",
          tag: "huidigeStapNaam text-uppercase",
        },
        passed: {
          number: "geweesteStapNummer",
          tag: "geweesteStapNaam text-uppercase",
        },
        idle: {
          number: "text-black",
          tag: "text-black text-uppercase",
        },
      },
      step: 1,
      // end return
    };
  },
  created() {
    this.runStepper();
  },
  beforeUpdate() {},
  methods: {
    runStepper() {
      this.step = this.getStep();
      this.steps.step1 = this.stepClass(1);
      this.steps.step2 = this.stepClass(2);
      this.steps.step3 = this.stepClass(3);
      this.steps.step4 = this.stepClass(4);
    },
    getStep() {
      let step = 1;

      // get path properties
      let routes = this.$router.options.routes;
      let routeName = this.$route.name;

      for (let index in routes) {
        if (routes[index].name === routeName) {
          step = routes[index].step;
        }
      }

      return step;
      // end getStep
    },
    stepClass(stepNumber) {
      let output = {
        number: this.classes.idle.number,
        tag: this.classes.idle.tag,
      };
      if (this.step > stepNumber) {
        output.number = this.classes.passed.number;
        output.tag = this.classes.passed.tag;
      } else if (this.step == stepNumber) {
        output.number = this.classes.current.number;
        output.tag = this.classes.current.tag;
      }
      return output;
    },
  },
  watch: {
    "$route.path": function () {
      this.runStepper();
    },
  },
};
</script>
<style scoped></style>
